// extracted by mini-css-extract-plugin
export var container = "_gx-0";
export var content = "_gx-3";
export var customerTitle = "_gx-4";
export var empty = "_gx-5";
export var gray = "_gx-6";
export var header = "_gx-7";
export var info = "_gx-8";
export var loading = "_gx-2";
export var loadingCard = "_gx-9";
export var oneLine = "_gx-a";
export var personName = "_gx-e";
export var pillContainer = "_gx-b";
export var selected = "_gx-1";
export var text = "_gx-c";
export var twoLines = "_gx-d";
export var unread = "_gx-f";
export var unreadIndicator = "_gx-g";